import { Pipe, PipeTransform } from '@angular/core';
import { ui } from '@qwyk/models';

@Pipe({
    standalone: true,
    name: 'locationCode',
})
export class LocationCodePipe implements PipeTransform {
    transform(address: ui.GooglePlacesAddress): string | null {
        if (!address) {
            return null;
        }

        const placeId = address.placeId;
        const lng = address.position?.lng;
        const lat = address.position?.lat;
        const countryCode = address.countryCode;
        const postalCode = address.postalCode || '';

        return `G:${placeId}|X:${lng}|Y:${lat}|C:${countryCode}|P:${postalCode}`;
    }
}
